import React from 'react';
import moment from 'moment';
import 'moment/locale/ru';
import focusWithin from 'focus-within';

import './PguFormGrid.pcss';
import './App.pcss';
import app from './setup';

moment.locale('ru');
focusWithin(document, { force: true });

app.router(require('./Router').router);

export default app.start();
